export enum ErrorActivity {
    LOGOUT,
    REDIRECT,
    SHOW_ONLY_MESSAGE
}

export enum RequestTranslationErrorGroup {
    GENERAL = 'request',
    SERVER = 'request.server',
    VALIDATION = 'request.validation',
    AUTHENTICATION = 'request.authentication',
}

export enum RequestClientErrorStatus {
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404
}

export enum RequestServerErrorStatus {
    INTERNAL_SERVER_ERROR = 500,
    NOT_IMPLEMENTED,
    BAD_GATEWAY,
    SERVICE_UNAVAILABLE,
    GATEWAY_TIMEOUT,
    HTTP_VERSION_NOT_SUPPORTED,
    VARIANT_ALSO_NEGOTIATES,
    INSUFFICIENT_STORAGE,
    LOOP_DETECTED,
    NOT_EXTENDED = 510,
    NETWORK_AUTHENTICATION_REQUIRED
}

export enum RequestErrorCode {
    FINGERPRINT_PERSON_TOO_YOUNG = 'errors.request.person.too.young',
    FINGERPRINTS_NOT_FOUND = 'errors.request.biometry.fingerprints.not.found'
}

export enum RequestErrorCodeIgnoreKey {
    FINGERPRINT_PERSON_TOO_YOUNG = RequestErrorCode.FINGERPRINT_PERSON_TOO_YOUNG
}

export enum RequestErrorMessageTitle {
    FINGERPRINTS_NOT_FOUND = 'errors.request.biometry.fingerprints.title'
}
